import { Backend } from './Backend';
import AppAuthToken from '../Security/AppAuthToken';

export const BackendFactory = (): Promise<Backend> => AppAuthToken.getAuthData().then((token) => new Backend(token));
